<template>
  <div class="device-comp-bd tb" v-if="funcView.device_comp_list">
    <div class="search-hd">
      <el-form :inline="true" class="search-form" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" :disabled="exporting" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_deviceComponent.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-radio-group style="float: right; margin-right: 8px" v-model="formSearch.type" @change="onPageChange({ page: 1 })">
          <el-radio-button :label="item.value" v-for="(item, index) in typeData" :key="index">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onSearch" @clear="clearFilter('')">
      <el-form :inline="true" label-position="top">
        <!-- 产品型号 -->
        <el-form-item :label="$t('dms_deviceComponent.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :listener="formSearch.websiteCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
            @change="onComponentCode([])"
          ></custom-select>
        </el-form-item>
        <!-- 组件代号 -->
        <el-form-item :label="$t('dms_deviceComponent.zu_jian_dai_hao')">
          <el-input v-model="formSearch.componentCode" clearable></el-input>
        </el-form-item>
        <!-- 固件版本 -->
        <el-form-item v-if="formSearch.productCode && formSearch.componentCode" :label="$t('dms_deviceComponent.gu_jian_ban_ben')">
          <custom-select
            v-show="isShowSelectVersion"
            v-model="formSearch.fwVersionList"
            :multiple="true"
            url="resourceSelect2List"
            :listener="`${formSearch.productCode}${formSearch.componentCode}`"
            :params="{ productCode: formSearch.productCode, componentCode: formSearch.componentCode }"
            :props="{ label: 'fwVersion', value: 'fwVersion' }"
            :placeholder="$t('Common.com_please_select')"
            @getList="onComponentCode"
          ></custom-select>
          <el-input v-show="!isShowSelectVersion" v-model="formSearch.fwVersion" clearable></el-input>
        </el-form-item>
        <el-form-item v-else :label="$t('dms_deviceComponent.gu_jian_ban_ben')">
          <el-input v-model="formSearch.fwVersion" clearable></el-input>
        </el-form-item>
        <!-- 固件升级时间 -->
        <el-form-item :label="$t('dms_deviceComponent.gjsjsj')">
          <custom-date-picker
            style="width: 100%"
            v-model="fwVersionGmtModified"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_deviceComponent.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_deviceComponent.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
        <!-- 零件SN partDataSn -->
        <el-form-item :label="$t('dms_deviceComponent.deng_jiSNshu_juSN')">
          <el-input v-model="formSearch.partDataSn" clearable></el-input>
        </el-form-item>
        <!-- 数据SN更新时间 -->
        <el-form-item :label="$t('dms_deviceComponent.sjSNgxsj')">
          <custom-date-picker
            style="width: 100%"
            v-model="dataSnGmtModified"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_deviceComponent.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_deviceComponent.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
        <!-- 最后更换时间 -->
        <el-form-item :label="$t('dms_deviceComponent.zhghsj')">
          <custom-date-picker
            style="width: 100%"
            v-model="lastReplaceTime"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_deviceComponent.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_deviceComponent.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
        <!-- 零件编号 -->
        <el-form-item :label="$t('dms_deviceComponent.ling_jian_bian_hao')">
          <el-input v-model="formSearch.partCode" clearable></el-input>
        </el-form-item>
        <!-- 零件名称 -->
        <el-form-item :label="$t('dms_deviceComponent.ling_jian_ming_cheng')">
          <el-input v-model="formSearch.partName" clearable></el-input>
        </el-form-item>
        <!-- 站点 -->
        <el-form-item :label="$t('dms_deviceComponent.zhan_dian')">
          <el-input v-model="formSearch.siteName" clearable></el-input>
        </el-form-item>
        <!-- 项目 -->
        <el-form-item :label="$t('dms_deviceComponent.xiang_mu')">
          <el-input v-model="formSearch.locationName" clearable></el-input>
        </el-form-item>
        <!-- 客户 -->
        <el-form-item :label="$t('dms_deviceComponent.ke_hu')">
          <el-input v-model="formSearch.customerName" clearable></el-input>
        </el-form-item>
        <!-- 集团客户 -->
        <el-form-item :label="$t('dms_deviceComponent.ji_tuan_ke_hu')">
          <el-input v-model="formSearch.bigCustomerName" clearable></el-input>
        </el-form-item>
        <!-- 代理 -->
        <el-form-item :label="$t('dms_deviceComponent.dai_li')">
          <el-input v-model="formSearch.agentCoName" clearable></el-input>
        </el-form-item>
        <!-- 售后 -->
        <el-form-item :label="$t('dms_deviceComponent.shou_hou')">
          <el-input v-model="formSearch.afterServiceName" clearable></el-input>
        </el-form-item>
        <!-- 机器版本 -->
        <el-form-item :label="$t('dms_deviceComponent.ji_qi_ban_ben')">
          <el-input v-model="formSearch.machineVersion" clearable></el-input>
        </el-form-item>

        <!-- 硬件版本 -->
        <!-- <el-form-item :label="$t('page_deviceComp_yjbb')">
          <el-input
            v-model="formSearch.hwVersion"
            clearable
          ></el-input>
        </el-form-item> -->
        <!-- 型号 -->
        <!-- <el-form-item :label="$t('page_deviceComp_xing_hao')">
          <el-input
            v-model="formSearch.model"
            clearable
          ></el-input>
        </el-form-item> -->
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table :data="tableList" height="100%" @filter="filterChange" @sort="sortChange" :column="tableColumn" :slots="['bodyNum']">
        <template slot="bodyNum" slot-scope="scope">
          <div v-if="scope.row.bodyNum" class="cell-link" @click="jump('/devicedetail', { bodyNum: scope.row.bodyNum, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
        </template>
      </custom-table>
    </div>
    <!-- 分页 -->
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>

    <device-component-dialog v-if="editVisible" @close="editVisible = false" :model="editModel" @success="getTableList"></device-component-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import deviceComponentDialog from './children/device_comp_edit_dialog.vue';


export default {
  name: 'deviceComponent',
  mixins: [resetFormSearchMixins, tableFilterValueMixins],
  components: {
    deviceComponentDialog,
  },
  computed: {
    typeData() {
      return [
        {
          value: 0,
          name: this.$t('Common.com_all'),
        },
        {
          value: 1,
          name: 'SN',
        },
        {
          value: 2,
          name: this.$t('dms_deviceComponent.gu_jian'),
        },
      ];
    },
  },
  data() {
    return {
      isShowSelectVersion: false,
      exporting: false,
      tableCode: 'device_comp_list',
      totalRows: 0,
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,

        // 数据类型：0-全部 1-SN 2-固件
        type: 0,

        // 高级搜索
        // 组件代号
        componentCode: '',
        // 机器版本
        machineVersion: '',
        // 产品型号
        productCode: '',
        // 零件编号
        partCode: '',
        // 零件名称
        partName: '',
        // 固件版本
        fwVersion: '',
        fwVersionList: [],
        // 硬件版本
        hwVersion: '',
        // 型号
        model: '',
        // 零件SN
        partDataSn: '',
        fwVersionGmtModifiedStart: '',
        fwVersionGmtModifiedEnd: '',
        dataSnGmtModifiedStart: '',
        dataSnGmtModifiedEnd: '',
        lastReplaceTimeStart: '',
        lastReplaceTimeEnd: '',
        siteName: '',
        locationName: '',
        customerName: '',
        bigCustomerName: '',
        agentCoName: '',
        afterServiceName: '',
      },

      fwVersionGmtModified: [],
      dataSnGmtModified: [],
      lastReplaceTime: [],
      tableList: [],

      link: null,

      editModel: {},

      editVisible: false,
    };
  },
  watch: {},
  mounted: function () {
    this.getTableColumn();

    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    onComponentCode(list) {
      const hasVersion = !!list.length;
      this.isShowSelectVersion = hasVersion;
      if (this.hasVersion) {
        this.formSearch.fwVersion = '';
      } else {
        this.formSearch.fwVersionList = [];
      }
    },
    onEdit(row) {
      const bodyNum = row.bodyNum;
      this.editModel = {
        title: this.$t('dms_deviceComponent.bjyjbbo', [bodyNum]),
        data: row,
      };
      this.editVisible = true;
    },

    onSearch() {
      this.onPageChange({ page: 1 });
    },
    exportTable() {
      // 导出过程中禁止重复触发，避免多个全屏 Loading 实例互相影响
      if (this.exporting) {
        return;
      }
      this.exporting = true;

      const reqData = {
        ...this.formSearch,
      };
      delete reqData.pageSize;
      delete reqData.pageNum;

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      const finishExport = () => {
        loading.close();
        this.exporting = false;
      };
      // 无论导出成功还是失败，都需要关闭 Loading 并释放点击锁
      this.$exportFlie(apis.deviceStructureExport, reqData).then(finishExport, finishExport);
    },
    // 获取设备事件列表
    getTableList: function () {
      this.formSearch.fwVersionGmtModifiedStart = this.fwVersionGmtModified ? this.fwVersionGmtModified[0] : '';
      this.formSearch.fwVersionGmtModifiedEnd = this.fwVersionGmtModified ? this.fwVersionGmtModified[1] : '';
      this.formSearch.dataSnGmtModifiedStart = this.dataSnGmtModified ? this.dataSnGmtModified[0] : '';
      this.formSearch.dataSnGmtModifiedEnd = this.dataSnGmtModified ? this.dataSnGmtModified[1] : '';
      this.formSearch.lastReplaceTimeStart = this.lastReplaceTime ? this.lastReplaceTime[0] : '';
      this.formSearch.lastReplaceTimeEnd = this.lastReplaceTime ? this.lastReplaceTime[1] : '';
      this.$getDebounceJSON(apis.deviceStructurePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.device-comp-bd {
  .search-form {
    .el-form-item__content {
      width: 100%;
    }
  }
}
</style>
